
let BUTTON = {};

BUTTON.TYPE_REGISTER  = 'register';
BUTTON.TYPE_WAITLIST  = 'waitlist';
BUTTON.TYPE_UPDATE    = 'update';
BUTTON.TYPE_CANCEL    = 'cancel';

BUTTON.NAME_REGISTER  = 'Register';
BUTTON.NAME_WAITLIST  = 'Waitlist';
BUTTON.NAME_UPDATE    = 'Update';
BUTTON.NAME_CANCEL    = 'Cancel';

BUTTON.ICON_REGISTER  = 'plus';
BUTTON.ICON_WAITLIST  = 'plus';
BUTTON.ICON_UPDATE    = 'save';
BUTTON.ICON_CANCEL    = 'ban';

export default BUTTON;